import { Correspondence } from '../../../interfaces/Correspondence';
import { CorrespondenceBehaviourDto } from '../../../interfaces/dtos/CorrespondenceBehaviourDto';
import { CorrespondenceDto } from '../../../interfaces/dtos/CorrespondenceDto';

export default function transformCorrespondence(dto: CorrespondenceDto, behaviours: CorrespondenceBehaviourDto): Correspondence {
  return {
    language: dto.language,
    behaviours: {
      showSection: behaviours.showSection,
    },
  };
}
